import React from 'react';
import {Field, reduxForm} from 'redux-form'
import FlatButton from 'material-ui/FlatButton';
import MenuItem from 'material-ui/MenuItem';

import DoneIcon from 'material-ui/svg-icons/action/done';
import SearchIcon from 'material-ui/svg-icons/action/search';
import ArrowDwonloadIcon from 'material-ui/svg-icons/file/file-download';
import LockIcon from 'material-ui/svg-icons/action/lock-outline';
import * as colors from 'material-ui/styles/colors';


import FormText from '../../components/FormText'
import FormSelect from '../../components/FormSelect'



class RoumuListForm extends React.Component {


  render() {

    const {
      branchOfficeData,
      departmentData,
      priceData,
      selectedBranchOfficeId,
      error,
      reset,
      handleSubmit,
      initialValues,
      onFormRegistClick,
      onFormSearchClick,
      onFormResetClick,
      onLocalStorageSave
     } = this.props

    return (

      <form onSubmit={handleSubmit(() => {})}>

        {error && <div><span style={{ color: 'rgb(244, 67, 54)' }}>{error}</span></div>}
        
          <div className="row">

             <div className="col-3">

              <Field
                name="branchOfficeId"
                component={FormSelect}
                style={{ width: '100%' }}
                label="支店名"
              >
                {
                  branchOfficeData && branchOfficeData.map((x, index) => {
                    return (<MenuItem key={index} value={x.id} primaryText={x.name} />)
                  })
                }
              </Field>

            </div> 

             <div className="col-3">

              <Field
                name="departmentId"
                component={FormSelect}
                style={{ width: '100%' }}
                label="部署名"
              >

                <MenuItem value={''} primaryText="" />
                {!departmentData ? '' :
                selectedBranchOfficeId ?
                 departmentData.map((x, index) =>{
                   if (selectedBranchOfficeId == x.branchOfficeId) {
                      return (<MenuItem key={index} value={x.id} primaryText={x.name}/>)
                   }
                 }) : 
                 <MenuItem primaryText="支店を選択" />
                }

              </Field>

            </div> 



          </div>

          <div className="row" style={{marginTop: 20}}>

            <div className="col-12" style={{textAlign: 'right'}}>
              <FlatButton
                label="クリア"
                primary={true}
                labelStyle={{ color: colors.grey500, lineHeight: '40px' }}
                style={{height: '40px', width: '100px', marginRight: '20px'}}
                onClick={() => {
                  reset()
                  onFormResetClick()
                }}
              />

              <FlatButton
                label="固定"
                labelPosition="before"
                primary={true}
                labelStyle={{color: colors.white, lineHeight: '40px'}}
                style={{height: '40px', width: '100px', marginRight: '20px'}}
                backgroundColor={colors.grey600}
                hoverColor={colors.grey700}
                icon={<LockIcon color={colors.white}/>}
                onClick={handleSubmit(onLocalStorageSave)}
              />

              <FlatButton
                label="検索"
                labelPosition="before"
                primary={true}
                labelStyle={{ color: colors.white, lineHeight: '40px' }}
                style={{ height: '40px', width: '100px' }}
                backgroundColor={colors.blue500}
                hoverColor={colors.blue700}
                icon={<SearchIcon color={colors.white} />}
                onClick={handleSubmit(onFormSearchClick)}
              />

            </div>
          </div>

      </form>

    )

  }

}

RoumuListForm = reduxForm({
  form: 'roumuMasterForm',
  enableReinitialize: true,
})(RoumuListForm)

export default RoumuListForm




// WEBPACK FOOTER //
// ./src/containers/roumu/RoumuListForm.js